if (!customElements.get('niceye-image-gallery')) {
  customElements.define('niceye-image-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const images = JSON.parse(this.querySelector('.ny-gallery-data').textContent);
      const main = this.querySelector('.ny-gallery-main');
      const rail = this.querySelector('.ny-gallery-thumbs');
      const status = this.querySelector('.ny-gallery-status');
      const dialog = this.querySelector('dialog');
      const select = (index) => {
        const image = images[index];
        main.src = image.src;
        main.alt = image.alt;
        this.dataset.selectedIndex = String(index);
        [...rail.children].forEach((button, i) => {
          if (i === index) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
        status.textContent = `Image ${index + 1} of ${images.length}`;
      };
      images.forEach((image, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ny-gallery-thumb';
        button.setAttribute('aria-label', `Show product image ${index + 1}: ${image.alt}`);
        const thumb = document.createElement('img');
        thumb.src = image.src;
        thumb.alt = '';
        thumb.loading = 'lazy';
        thumb.width = 84; thumb.height = 84;
        button.append(thumb);
        button.addEventListener('click', () => select(index));
        rail.append(button);
      });
      if (images.length) {
        this.classList.add('has-thumbnails');
        select(0);
      }
      for (const part of ['heading', 'highlights']) {
        const destination = document.querySelector(`[data-ny-variant-${part}]`);
        const source = this.querySelector(`.ny-selected-${part}`);
        if (destination && source) destination.replaceChildren(source.content.cloneNode(true));
      }
      const details = document.querySelector('[data-ny-variant-details]');
      const selectedDescription = this.querySelector('.ny-selected-description');
      if (details && selectedDescription) details.replaceChildren(selectedDescription.content.cloneNode(true));
      this.querySelector('.ny-gallery-zoom').addEventListener('click', () => {
        const enlarged = dialog.querySelector('img');
        enlarged.src = main.src; enlarged.alt = main.alt;
        dialog.showModal();
      });
      this.querySelector('.ny-gallery-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    }
  });
}
